module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-33.aaaad9e3.png";